export const defaultSrc = '/default.svg';

interface ImageParams {
  src?: string;
  fit?: 'cover' | 'contain' | 'fill' | 'inside' | 'outside';
  auto?: boolean;
  format?: 'jpeg' | 'webp' | 'avif';
  enlarge?: boolean;
  background?: string;
  sizes?: string;
  width?: number | string;
  height?: number | string;
}

function generateIpxUrl(imageParams: ImageParams): string {
  const url = imageParams.src || defaultSrc;
  const params = new URLSearchParams();
  params.append('f', 'jpeg');
  if (!imageParams.auto) params.append('s', '488x650');
  params.append('fit', imageParams.fit ?? 'cover');
  params.append('url', url);

  if (imageParams.enlarge) params.append('enlarge', 'true');
  if (imageParams.background) {
    params.append('bg', imageParams.background);
  }

  if (imageParams.width) params.append('w', imageParams.width.toString());
  if (imageParams.height) params.append('h', imageParams.height.toString());

  params.append('format', imageParams.format ?? 'avif');

  if (imageParams.sizes) params.append('sizes', imageParams.sizes);

  return `/_ipx/${params.toString()}`;
}

function generateFastlyUrl(imageParams: ImageParams): string {
  const url = imageParams.src || defaultSrc;
  const params = new URLSearchParams();
  params.append('fit', imageParams.fit ?? 'cover');

  if (imageParams.enlarge) params.append('enlarge', 'true');
  if (imageParams.background) {
    params.append('bg-color', imageParams.background);
  }

  if (imageParams.sizes) params.append('sizes', imageParams.sizes);
  if (imageParams.width) params.append('width', imageParams.width.toString());
  if (imageParams.height) params.append('height', imageParams.height.toString());

  params.append('format', imageParams.format ?? 'avif');

  return `${url}?${params.toString()}`;
}

export function generateUrl(imageParams: ImageParams, provider: 'ipx' | 'fastly'): string {
  if (provider === 'ipx') {
    return generateIpxUrl(imageParams);
  } else if (provider === 'fastly') {
    return generateFastlyUrl(imageParams);
  } else {
    throw new Error('Invalid image provider specified');
  }
}
